/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getProgramDerivedAddress,
  getStructDecoder,
  getStructEncoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
  SolanaError,
  transformEncoder,
  type AccountMeta,
  type AccountSignerMeta,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type Instruction,
  type InstructionWithAccounts,
  type InstructionWithData,
  type ReadonlyAccount,
  type ReadonlySignerAccount,
  type ReadonlyUint8Array,
  type TransactionSigner,
  type WritableAccount,
} from '@solana/kit';
import {
  getAccountMetaFactory,
  getAddressFromResolvedInstructionAccount,
  type ResolvedInstructionAccount,
} from '@solana/program-client-core';
import { CPMM_PROGRAM_ADDRESS } from '../programs';

export const WITHDRAW_VAULT_EXCESS_DISCRIMINATOR = new Uint8Array([
  235, 197, 247, 177, 137, 72, 135, 113,
]);

export function getWithdrawVaultExcessDiscriminatorBytes() {
  return fixEncoderSize(getBytesEncoder(), 8).encode(
    WITHDRAW_VAULT_EXCESS_DISCRIMINATOR,
  );
}

export type WithdrawVaultExcessInstruction<
  TProgram extends string = typeof CPMM_PROGRAM_ADDRESS,
  TAccountConfig extends string | AccountMeta<string> = string,
  TAccountPool extends string | AccountMeta<string> = string,
  TAccountAdmin extends string | AccountMeta<string> = string,
  TAccountAuthority extends string | AccountMeta<string> = string,
  TAccountVault0 extends string | AccountMeta<string> = string,
  TAccountVault1 extends string | AccountMeta<string> = string,
  TAccountToken0Mint extends string | AccountMeta<string> = string,
  TAccountToken1Mint extends string | AccountMeta<string> = string,
  TAccountAdminAta0 extends string | AccountMeta<string> = string,
  TAccountAdminAta1 extends string | AccountMeta<string> = string,
  TAccountToken0Program extends string | AccountMeta<string> = string,
  TAccountToken1Program extends string | AccountMeta<string> = string,
  TRemainingAccounts extends readonly AccountMeta<string>[] = [],
> = Instruction<TProgram> &
  InstructionWithData<ReadonlyUint8Array> &
  InstructionWithAccounts<
    [
      TAccountConfig extends string
        ? ReadonlyAccount<TAccountConfig>
        : TAccountConfig,
      TAccountPool extends string
        ? ReadonlyAccount<TAccountPool>
        : TAccountPool,
      TAccountAdmin extends string
        ? ReadonlySignerAccount<TAccountAdmin> &
            AccountSignerMeta<TAccountAdmin>
        : TAccountAdmin,
      TAccountAuthority extends string
        ? ReadonlyAccount<TAccountAuthority>
        : TAccountAuthority,
      TAccountVault0 extends string
        ? WritableAccount<TAccountVault0>
        : TAccountVault0,
      TAccountVault1 extends string
        ? WritableAccount<TAccountVault1>
        : TAccountVault1,
      TAccountToken0Mint extends string
        ? ReadonlyAccount<TAccountToken0Mint>
        : TAccountToken0Mint,
      TAccountToken1Mint extends string
        ? ReadonlyAccount<TAccountToken1Mint>
        : TAccountToken1Mint,
      TAccountAdminAta0 extends string
        ? WritableAccount<TAccountAdminAta0>
        : TAccountAdminAta0,
      TAccountAdminAta1 extends string
        ? WritableAccount<TAccountAdminAta1>
        : TAccountAdminAta1,
      TAccountToken0Program extends string
        ? ReadonlyAccount<TAccountToken0Program>
        : TAccountToken0Program,
      TAccountToken1Program extends string
        ? ReadonlyAccount<TAccountToken1Program>
        : TAccountToken1Program,
      ...TRemainingAccounts,
    ]
  >;

export type WithdrawVaultExcessInstructionData = {
  discriminator: ReadonlyUint8Array;
};

export type WithdrawVaultExcessInstructionDataArgs = {};

export function getWithdrawVaultExcessInstructionDataEncoder(): FixedSizeEncoder<WithdrawVaultExcessInstructionDataArgs> {
  return transformEncoder(
    getStructEncoder([['discriminator', fixEncoderSize(getBytesEncoder(), 8)]]),
    (value) => ({
      ...value,
      discriminator: WITHDRAW_VAULT_EXCESS_DISCRIMINATOR,
    }),
  );
}

export function getWithdrawVaultExcessInstructionDataDecoder(): FixedSizeDecoder<WithdrawVaultExcessInstructionData> {
  return getStructDecoder([
    ['discriminator', fixDecoderSize(getBytesDecoder(), 8)],
  ]);
}

export function getWithdrawVaultExcessInstructionDataCodec(): FixedSizeCodec<
  WithdrawVaultExcessInstructionDataArgs,
  WithdrawVaultExcessInstructionData
> {
  return combineCodec(
    getWithdrawVaultExcessInstructionDataEncoder(),
    getWithdrawVaultExcessInstructionDataDecoder(),
  );
}

export type WithdrawVaultExcessAsyncInput<
  TAccountConfig extends string = string,
  TAccountPool extends string = string,
  TAccountAdmin extends string = string,
  TAccountAuthority extends string = string,
  TAccountVault0 extends string = string,
  TAccountVault1 extends string = string,
  TAccountToken0Mint extends string = string,
  TAccountToken1Mint extends string = string,
  TAccountAdminAta0 extends string = string,
  TAccountAdminAta1 extends string = string,
  TAccountToken0Program extends string = string,
  TAccountToken1Program extends string = string,
> = {
  config: Address<TAccountConfig>;
  pool: Address<TAccountPool>;
  admin: TransactionSigner<TAccountAdmin>;
  authority?: Address<TAccountAuthority>;
  vault0: Address<TAccountVault0>;
  vault1: Address<TAccountVault1>;
  token0Mint: Address<TAccountToken0Mint>;
  token1Mint: Address<TAccountToken1Mint>;
  adminAta0?: Address<TAccountAdminAta0>;
  adminAta1?: Address<TAccountAdminAta1>;
  token0Program: Address<TAccountToken0Program>;
  token1Program: Address<TAccountToken1Program>;
};

export async function getWithdrawVaultExcessInstructionAsync<
  TAccountConfig extends string,
  TAccountPool extends string,
  TAccountAdmin extends string,
  TAccountAuthority extends string,
  TAccountVault0 extends string,
  TAccountVault1 extends string,
  TAccountToken0Mint extends string,
  TAccountToken1Mint extends string,
  TAccountAdminAta0 extends string,
  TAccountAdminAta1 extends string,
  TAccountToken0Program extends string,
  TAccountToken1Program extends string,
  TProgramAddress extends Address = typeof CPMM_PROGRAM_ADDRESS,
>(
  input: WithdrawVaultExcessAsyncInput<
    TAccountConfig,
    TAccountPool,
    TAccountAdmin,
    TAccountAuthority,
    TAccountVault0,
    TAccountVault1,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountAdminAta0,
    TAccountAdminAta1,
    TAccountToken0Program,
    TAccountToken1Program
  >,
  config?: { programAddress?: TProgramAddress },
): Promise<
  WithdrawVaultExcessInstruction<
    TProgramAddress,
    TAccountConfig,
    TAccountPool,
    TAccountAdmin,
    TAccountAuthority,
    TAccountVault0,
    TAccountVault1,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountAdminAta0,
    TAccountAdminAta1,
    TAccountToken0Program,
    TAccountToken1Program
  >
> {
  // Program address.
  const programAddress = config?.programAddress ?? CPMM_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    config: { value: input.config ?? null, isWritable: false },
    pool: { value: input.pool ?? null, isWritable: false },
    admin: { value: input.admin ?? null, isWritable: false },
    authority: { value: input.authority ?? null, isWritable: false },
    vault0: { value: input.vault0 ?? null, isWritable: true },
    vault1: { value: input.vault1 ?? null, isWritable: true },
    token0Mint: { value: input.token0Mint ?? null, isWritable: false },
    token1Mint: { value: input.token1Mint ?? null, isWritable: false },
    adminAta0: { value: input.adminAta0 ?? null, isWritable: true },
    adminAta1: { value: input.adminAta1 ?? null, isWritable: true },
    token0Program: { value: input.token0Program ?? null, isWritable: false },
    token1Program: { value: input.token1Program ?? null, isWritable: false },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Resolve default values.
  if (!accounts.authority.value) {
    accounts.authority.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([97, 117, 116, 104, 111, 114, 105, 116, 121]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount('pool', accounts.pool.value),
        ),
      ],
    });
  }
  if (!accounts.adminAta0.value) {
    accounts.adminAta0.value = await getProgramDerivedAddress({
      programAddress:
        'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>,
      seeds: [
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'admin',
            accounts.admin.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'token0Program',
            accounts.token0Program.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'token0Mint',
            accounts.token0Mint.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.adminAta1.value) {
    accounts.adminAta1.value = await getProgramDerivedAddress({
      programAddress:
        'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>,
      seeds: [
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'admin',
            accounts.admin.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'token1Program',
            accounts.token1Program.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'token1Mint',
            accounts.token1Mint.value,
          ),
        ),
      ],
    });
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('config', accounts.config),
      getAccountMeta('pool', accounts.pool),
      getAccountMeta('admin', accounts.admin),
      getAccountMeta('authority', accounts.authority),
      getAccountMeta('vault0', accounts.vault0),
      getAccountMeta('vault1', accounts.vault1),
      getAccountMeta('token0Mint', accounts.token0Mint),
      getAccountMeta('token1Mint', accounts.token1Mint),
      getAccountMeta('adminAta0', accounts.adminAta0),
      getAccountMeta('adminAta1', accounts.adminAta1),
      getAccountMeta('token0Program', accounts.token0Program),
      getAccountMeta('token1Program', accounts.token1Program),
    ],
    data: getWithdrawVaultExcessInstructionDataEncoder().encode({}),
    programAddress,
  } as WithdrawVaultExcessInstruction<
    TProgramAddress,
    TAccountConfig,
    TAccountPool,
    TAccountAdmin,
    TAccountAuthority,
    TAccountVault0,
    TAccountVault1,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountAdminAta0,
    TAccountAdminAta1,
    TAccountToken0Program,
    TAccountToken1Program
  >);
}

export type WithdrawVaultExcessInput<
  TAccountConfig extends string = string,
  TAccountPool extends string = string,
  TAccountAdmin extends string = string,
  TAccountAuthority extends string = string,
  TAccountVault0 extends string = string,
  TAccountVault1 extends string = string,
  TAccountToken0Mint extends string = string,
  TAccountToken1Mint extends string = string,
  TAccountAdminAta0 extends string = string,
  TAccountAdminAta1 extends string = string,
  TAccountToken0Program extends string = string,
  TAccountToken1Program extends string = string,
> = {
  config: Address<TAccountConfig>;
  pool: Address<TAccountPool>;
  admin: TransactionSigner<TAccountAdmin>;
  authority: Address<TAccountAuthority>;
  vault0: Address<TAccountVault0>;
  vault1: Address<TAccountVault1>;
  token0Mint: Address<TAccountToken0Mint>;
  token1Mint: Address<TAccountToken1Mint>;
  adminAta0: Address<TAccountAdminAta0>;
  adminAta1: Address<TAccountAdminAta1>;
  token0Program: Address<TAccountToken0Program>;
  token1Program: Address<TAccountToken1Program>;
};

export function getWithdrawVaultExcessInstruction<
  TAccountConfig extends string,
  TAccountPool extends string,
  TAccountAdmin extends string,
  TAccountAuthority extends string,
  TAccountVault0 extends string,
  TAccountVault1 extends string,
  TAccountToken0Mint extends string,
  TAccountToken1Mint extends string,
  TAccountAdminAta0 extends string,
  TAccountAdminAta1 extends string,
  TAccountToken0Program extends string,
  TAccountToken1Program extends string,
  TProgramAddress extends Address = typeof CPMM_PROGRAM_ADDRESS,
>(
  input: WithdrawVaultExcessInput<
    TAccountConfig,
    TAccountPool,
    TAccountAdmin,
    TAccountAuthority,
    TAccountVault0,
    TAccountVault1,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountAdminAta0,
    TAccountAdminAta1,
    TAccountToken0Program,
    TAccountToken1Program
  >,
  config?: { programAddress?: TProgramAddress },
): WithdrawVaultExcessInstruction<
  TProgramAddress,
  TAccountConfig,
  TAccountPool,
  TAccountAdmin,
  TAccountAuthority,
  TAccountVault0,
  TAccountVault1,
  TAccountToken0Mint,
  TAccountToken1Mint,
  TAccountAdminAta0,
  TAccountAdminAta1,
  TAccountToken0Program,
  TAccountToken1Program
> {
  // Program address.
  const programAddress = config?.programAddress ?? CPMM_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    config: { value: input.config ?? null, isWritable: false },
    pool: { value: input.pool ?? null, isWritable: false },
    admin: { value: input.admin ?? null, isWritable: false },
    authority: { value: input.authority ?? null, isWritable: false },
    vault0: { value: input.vault0 ?? null, isWritable: true },
    vault1: { value: input.vault1 ?? null, isWritable: true },
    token0Mint: { value: input.token0Mint ?? null, isWritable: false },
    token1Mint: { value: input.token1Mint ?? null, isWritable: false },
    adminAta0: { value: input.adminAta0 ?? null, isWritable: true },
    adminAta1: { value: input.adminAta1 ?? null, isWritable: true },
    token0Program: { value: input.token0Program ?? null, isWritable: false },
    token1Program: { value: input.token1Program ?? null, isWritable: false },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('config', accounts.config),
      getAccountMeta('pool', accounts.pool),
      getAccountMeta('admin', accounts.admin),
      getAccountMeta('authority', accounts.authority),
      getAccountMeta('vault0', accounts.vault0),
      getAccountMeta('vault1', accounts.vault1),
      getAccountMeta('token0Mint', accounts.token0Mint),
      getAccountMeta('token1Mint', accounts.token1Mint),
      getAccountMeta('adminAta0', accounts.adminAta0),
      getAccountMeta('adminAta1', accounts.adminAta1),
      getAccountMeta('token0Program', accounts.token0Program),
      getAccountMeta('token1Program', accounts.token1Program),
    ],
    data: getWithdrawVaultExcessInstructionDataEncoder().encode({}),
    programAddress,
  } as WithdrawVaultExcessInstruction<
    TProgramAddress,
    TAccountConfig,
    TAccountPool,
    TAccountAdmin,
    TAccountAuthority,
    TAccountVault0,
    TAccountVault1,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountAdminAta0,
    TAccountAdminAta1,
    TAccountToken0Program,
    TAccountToken1Program
  >);
}

export type ParsedWithdrawVaultExcessInstruction<
  TProgram extends string = typeof CPMM_PROGRAM_ADDRESS,
  TAccountMetas extends readonly AccountMeta[] = readonly AccountMeta[],
> = {
  programAddress: Address<TProgram>;
  accounts: {
    config: TAccountMetas[0];
    pool: TAccountMetas[1];
    admin: TAccountMetas[2];
    authority: TAccountMetas[3];
    vault0: TAccountMetas[4];
    vault1: TAccountMetas[5];
    token0Mint: TAccountMetas[6];
    token1Mint: TAccountMetas[7];
    adminAta0: TAccountMetas[8];
    adminAta1: TAccountMetas[9];
    token0Program: TAccountMetas[10];
    token1Program: TAccountMetas[11];
  };
  data: WithdrawVaultExcessInstructionData;
};

export function parseWithdrawVaultExcessInstruction<
  TProgram extends string,
  TAccountMetas extends readonly AccountMeta[],
>(
  instruction: Instruction<TProgram> &
    InstructionWithAccounts<TAccountMetas> &
    InstructionWithData<ReadonlyUint8Array>,
): ParsedWithdrawVaultExcessInstruction<TProgram, TAccountMetas> {
  if (instruction.accounts.length < 12) {
    throw new SolanaError(
      SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
      {
        actualAccountMetas: instruction.accounts.length,
        expectedAccountMetas: 12,
      },
    );
  }
  let accountIndex = 0;
  const getNextAccount = () => {
    const accountMeta = (instruction.accounts as TAccountMetas)[accountIndex]!;
    accountIndex += 1;
    return accountMeta;
  };
  return {
    programAddress: instruction.programAddress,
    accounts: {
      config: getNextAccount(),
      pool: getNextAccount(),
      admin: getNextAccount(),
      authority: getNextAccount(),
      vault0: getNextAccount(),
      vault1: getNextAccount(),
      token0Mint: getNextAccount(),
      token1Mint: getNextAccount(),
      adminAta0: getNextAccount(),
      adminAta1: getNextAccount(),
      token0Program: getNextAccount(),
      token1Program: getNextAccount(),
    },
    data: getWithdrawVaultExcessInstructionDataDecoder().decode(
      instruction.data,
    ),
  };
}
